import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-028570eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  ref: "plot",
  class: "nge-effort-plot"
}
const _hoisted_3 = { class: "nge-effort-cap" }
const _hoisted_4 = { class: "nge-effort-cap-start" }
const _hoisted_5 = {
  key: 0,
  class: "nge-effort-spans",
  role: "group",
  "aria-label": "Range"
}
const _hoisted_6 = ["aria-pressed", "title", "onClick"]
const _hoisted_7 = {
  key: 1,
  class: "nge-effort-cap-end"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("figure", {
    ref: "fig",
    class: _normalizeClass(["nge-effort", { 'is-done': $setup.done }]),
    style: _normalizeStyle({ '--c': $props.color, '--h': ($props.height ?? 76) + 'px' }),
    "aria-label": $setup.summary
  }, [
    _createCommentVNode(" the plot keeps its height before the record arrives, so the rows below never move "),
    _createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */),
    _createElementVNode("figcaption", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString($setup.startLabel), 1 /* TEXT */),
      _createCommentVNode(" the range: one choice shared by every curve on the page (the parent holds it) "),
      ($props.spans && $props.spans.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.spans, (s) => {
              return (_openBlock(), _createElementBlock("button", {
                key: s,
                type: "button",
                class: _normalizeClass(["nge-effort-span", { 'is-on': ($props.span ?? 0) === s }]),
                "aria-pressed": ($props.span ?? 0) === s,
                title: s ? 'The past ' + s + ' days' : 'Since your first day',
                onClick: $event => ($setup.emit('update:span', s))
              }, _toDisplayString($setup.spanLabel(s)), 11 /* TEXT, CLASS, PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.startLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Today"))
        : _createCommentVNode("v-if", true)
    ])
  ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
}